var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import ___default from "lodash";
import { getDefaultUserAccessReducerState } from "./UserAccess.reducer.js";
const getUserAccessStateById = (workspaceId, state) => {
  if (!!(state == null ? void 0 : state.userAccess.workspaces[workspaceId])) {
    return __spreadValues(__spreadValues({}, getDefaultUserAccessReducerState()), state.userAccess.workspaces[workspaceId]);
  }
  return getDefaultUserAccessReducerState();
};
const hasExperimentationGroupClaims = (workspaceId, experimentationGroupId, claims, state) => {
  const userAccessState = getUserAccessStateById(workspaceId, state);
  const { experimentationGroupClaims = {} } = userAccessState;
  const egClaims = experimentationGroupClaims[experimentationGroupId] || {};
  return hasClaims(claims, egClaims);
};
const hasWorkspaceClaims = (workspaceId, claims, state) => {
  const userAccessState = getUserAccessStateById(workspaceId, state);
  const { workspaceClaims = {} } = userAccessState;
  return hasClaims(claims, workspaceClaims);
};
const hasClaims = (claims, claimChecks) => {
  const { allClaims, someClaims = [] } = claims;
  const hasSomeClaims = someClaims.length === 0 || ___default.some(someClaims, (claim) => {
    var _a;
    return !!((_a = claimChecks[claim]) == null ? void 0 : _a.data);
  });
  const hasAllClaims = allClaims.length === 0 || ___default.every(allClaims, (claim) => {
    var _a;
    return !!((_a = claimChecks[claim]) == null ? void 0 : _a.data);
  });
  return hasSomeClaims && hasAllClaims;
};
export {
  getUserAccessStateById,
  hasExperimentationGroupClaims,
  hasWorkspaceClaims
};
//# sourceMappingURL=UserAccess.selectors.js.map
